import React from 'react'
import { IosIcon } from '../svgs/Svgs'

export function AppStoreButton({ link }) {
    return (
        <a
            href={link}
            target="_blank"
            className="p-[10px] cursor-pointer hover:shadow-md
         shadow-black dark:shadow-white rounded-[10px] border flex items-center gap-[10px]"
            rel="noreferrer"
        >
            <IosIcon className="dark:text-white" />
            <span className="font-[600] dark:text-white">App Store</span>
        </a>
    )
}
